


















































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { FaultsApi, ProductType } from '@/api';

@Component({})
export default class FilterTable extends Vue {
	public sortedItems: [] | undefined = [];
	@Prop(String) readonly id: string | null | undefined;
	@Prop(Array) readonly items: [] | undefined;

	public currentPage = 1;
	public perPage = 22;
	public totalRows: Number = 0;
	public async created() {
		this.sortedItems = this.items;
		this.getFaultTypeList();
	}

	public appliedFilters = {
		faultStatus: '',
		productType: '',
		search: '',
		faultTypes: [],
	};

	public sortCompare(aRow: { [x: string]: number }, bRow: { [x: string]: number }, key: string) {
		switch (key) {
			case 'faultStatus':
				let priority = { new: 5, rebooting: 4, monitor: 3, repair: 2, resolved: 1 };
				let a: number = priority[aRow[key]];
				let b: number = priority[bRow[key]];
				return a < b ? -1 : a > b ? 1 : 0;
				break;
			default:
				a = aRow[key];
				b = bRow[key];
				return a === null ? -1 : b === null ? 1 : a < b ? -1 : a > b ? 1 : 0;
				break;
		}
	}
	public faultTypes = [];
	public fields = [
		{
			sortable: true,
			key: 'productId',
			label: 'Id',
		},
		{
			sortable: true,
			key: 'faultStatus',
			label: 'Status',
		},
		{
			sortable: true,
			key: 'productName',
			label: 'Farm Info',
		},
		{
			sortable: true,
			key: 'entity_type',
			label: 'Entity Type',
		},
		{
			sortable: true,
			key: 'faultTypes',
			label: 'Fault Type',
		},
		{
			sortable: true,
			key: 'faultDate',
			label: 'Latest Fault',
		},
		{
			sortable: true,
			key: 'faultStatusUpdateDate',
			label: 'Status Update',
		},
		{
			sortable: true,
			key: 'faultFirstDate',
			label: 'First Fault Date',
		},
	];

	public filters = [
		{
			key: 'faultStatus',
			label: 'Fault Status',
			fields: [
				{ value: 'new', text: 'New' },
				{ value: 'rebooting', text: 'Rebooting' },
				{ value: 'monitor', text: 'Monitor' },
				{ value: 'repair', text: 'Repair' },
			],
		},
		{
			key: 'productType',
			label: 'Product Type',
			fields: [
				{ value: 'fuel', text: 'Fuel' },
				{ value: 'milk', text: 'Milk' },
				{ value: 'water', text: 'Water' },
				{ value: 'effluent', text: 'Effluent' },
				{ value: ProductType.Feed, text: 'Feed' },
			],
		},
	];

	public async getFaultTypeList() {
		try {
			const { data } = await new FaultsApi().getFaultTypes();
			if (data.data) {
				data.data.forEach(faultType =>
					this.faultTypes.push({
						checked: false,
						text: faultType.split(/(?=[A-Z])/).join(' '),
						value: faultType,
					}),
				);
			}
		} catch (e) {
			console.log(e);
		}
	}

	public onFiltered(filteredItems) {
		// Trigger pagination to update the number of buttons/pages due to filtering
		this.totalRows = filteredItems.length;
		this.currentPage = 1;
	}

	@Watch('items')
	public filterItems() {
		this.sortedItems = this.items;
		if (this.sortedItems) {
			if (this.appliedFilters.faultStatus !== '') {
				this.sortedItems = this.sortedItems.filter(
					(item: any) => item.faultStatus === this.appliedFilters['faultStatus'],
				);
			}
			if (this.appliedFilters.productType !== '') {
				this.sortedItems = this.sortedItems.filter(
					(item: any) => item.productType === this.appliedFilters['productType'],
				);
			}
			if (this.appliedFilters.faultTypes.length > 0) {
				this.sortedItems = this.sortedItems.filter((item: any) => {
					if (_.get(item, 'faultTypes') != null) {
						return this.appliedFilters['faultTypes'].some(val =>
							_.get(item, 'faultTypes')
								.split(',')
								.includes(val),
						);
					}
				});
			}
		}
		this.totalRows = this.sortedItems.length;
	}
}
